<template>
  <ul class="vue-pagination">
    <li v-for="(link, index) in links" :key="index" class="vue-pagination-item">

      <template v-if="index == 0 || index == links.length - 1">
        <router-link :class="{'btn-first': index == 0, 'btn-last': index == links.length - 1}" :to="link.url" v-if="link.url">
          <svg xmlns="http://www.w3.org/2000/svg" width="8.013" height="13.198" viewBox="0 0 8.013 13.198">
            <path id="Tracé_13" data-name="Tracé 13" d="M428.9,772l5.892,5.892-5.892,5.892" transform="translate(436.207 784.491) rotate(180)" fill="none" stroke="#fff" stroke-width="2"/>
          </svg>
        </router-link>
        <router-link class="disabled" :class="{'btn-first': index == 0, 'btn-last': index == links.length - 1}" to="#" v-else>
          <svg xmlns="http://www.w3.org/2000/svg" width="8.013" height="13.198" viewBox="0 0 8.013 13.198">
            <path id="Tracé_13" data-name="Tracé 13" d="M428.9,772l5.892,5.892-5.892,5.892" transform="translate(436.207 784.491) rotate(180)" fill="none" stroke="#fff" stroke-width="2"/>
          </svg>
        </router-link>
      </template>

      <template v-else>
        <router-link :class="{'active': link.active}" :to="link.url">{{ link.label }}</router-link>
      </template>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['data'],
  data() {
    return {

    }
  },
  methods: {
  },
  computed: {
    links() {
      if (this.data.links.length <= 3) {
        return this.data.links;
      }

      let length = this.data.links.length;
      let current = this.data.current_page;

      return this.data.links.filter(function (link, index) {

        // Affiche premier btn
        if (index == 0) return true;
        // Affiche last btn
        if (index + 1 == length) return true;
        // Affiche lien actif
        if (link.active) return true;

        // Previous et next item
        if (index == current - 1) return true;
        if (index == current + 1) return true;

        return false;
      });
    }
  },
  mounted() {
  }
}
</script>